const findLike = (likes, currentUser) =>
  likes.find((like) => like.user_id === currentUser.id);

const getLikeId = ({ dataLikes, currentUser }) => {
  if (!dataLikes.likes.length) {
    return null;
  }

  const like = findLike(dataLikes.likes, currentUser);

  if (!like) {
    return null;
  }

  return like.id;
};

export const getLikesFromData = ({ dataLikes, currentUser, id }) => {
  if (!dataLikes) {
    return null;
  }

  return {
    count: dataLikes.total_items,
    users: dataLikes.users,
    id: getLikeId({ dataLikes, currentUser }),
    likeable_id: id,
  };
};
